export class GoogleAnalytics {
    constructor($window) {
		'ngInject';

		this.$window = $window;
    }

    $onInit() {
        this.dataLayer = this.$window.dataLayer = this.$window.dataLayer || [];
    }

    pageView() {
        this.$window.dataLayer.push({
            event: 'pageView',
            attributes: {
                route : this.$window.location.href
             }
        });
    }

    event(eventName, attributes) {
        this.$window.dataLayer.push({
            event: eventName,
            attributes
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/common/libs/google-analytics/google-analytics.service.js